import { AppShell } from '@/components/layout/AppShell'
import { ThresholdsForm } from '@/components/settings/ThresholdsForm'
import { RolesGroupedList } from '@/components/settings/RolesGroupedList'
import { EventSettingsForm } from '@/components/settings/EventSettingsForm'

export function SettingsPage() {
  return (
    <AppShell>
      <article className="fade-in max-w-4xl">
        <header>
          <p className="tracked-caps text-[10px] text-faint">Einstellungen</p>
          <h2 className="mt-2 text-2xl text-ink">Profit-Taking</h2>
          <p className="mt-1 font-mono text-xs text-muted">
            Schwellen und Position-Rollen für die Gewinnmitnahme-Engine.
          </p>
        </header>

        <section className="mt-10" aria-labelledby="thresholds-heading">
          <h3 id="thresholds-heading" className="tracked-caps mb-3 text-[10px] text-bernstein">
            Schwellen
          </h3>
          <ThresholdsForm />
        </section>

        <section className="mt-10" aria-labelledby="roles-heading">
          <h3 id="roles-heading" className="tracked-caps mb-3 text-[10px] text-bernstein">
            Position-Rollen
          </h3>
          <RolesGroupedList />
        </section>

        <section className="mt-10" aria-labelledby="events-heading">
          <h3 id="events-heading" className="tracked-caps mb-3 text-[10px] text-bernstein">
            Event-Alerts
          </h3>
          <EventSettingsForm />
        </section>
      </article>
    </AppShell>
  )
}
